/* eslint-disable no-undef */
import './_bootstrap.js'
import './bugsnag/bugsnag'
import './ie11-shims.js'

import { get } from 'lodash'
import Vue from 'vue'
import type { Route } from 'vue-router'
import VueRouter from 'vue-router'

// @ts-ignore
import { UserActivityController } from '../_controllers/UserActivityController.js'
import tripDashboardAxios from '../_framework/axios/trip-dashboard-axios'
import App from './components/App.vue'
import Routes from './components/routes'
import { TripDashboardStore } from './stores/_store_trip_dashboard'
import { refreshTripDashboard, setupDashboard } from // @ts-ignore
'./stores/TripDashboardsCollection.js'
// Initialize event bus (side effect import)
import './utils/eventBus'

Vue.use(VueRouter)

const clearLoader = () => {
  const loader = document.getElementById('full-page-loader')
  if (loader) {
    loader.className += ' hidden'
    setTimeout(() => {
      const scopedLoader = document.getElementById('full-page-loader')
      if (scopedLoader) {
        // @ts-ignore
        scopedLoader.parentNode.removeChild(scopedLoader)
      }
    }, 400)
  }
}

// @ts-ignore
const ready = storeCtx => {
  storeCtx.dispatch('appReady')
  storeCtx.commit('appReady')
  setTimeout(() => {
    clearLoader()
  }, 100)

  // ping so that the form does not time out
  const pingHello = () => {
    // TODO: refactor this
    // @ts-ignore
    window.axios.get('/ping')
  }

  setInterval(pingHello, 10 * 60 * 1000)
}

if (document.getElementById('trip-dashboard')) {
  /*
    |--------------------------------------------------------------------------
    | ROUTER INIT AND EVENTS
    |--------------------------------------------------------------------------
    */

  const router = new VueRouter({
    // base: '/',
    mode: 'history',
    routes: Routes
  })

  router.beforeEach(function (to, from, next) {
    /*
    |--------------------------------------------------------------------------
    | PAYMENT TERMINAL
    |--------------------------------------------------------------------------
    */

    // guest routes
    // @ts-ignore // TODO: do not ignore
    if (to.matched[0].name === 'payment-terminal') {
      ready(TripDashboardStore)
    } // other routes
    else {
      TripDashboardStore.dispatch('startup')
      // @ts-ignore // TODO: do not ignore
      if (to.matched[0].path === '/trips/:dashboardId') {
        /*
        |--------------------------------------------------------------------------
        | TRIP
        |--------------------------------------------------------------------------
        */
        const dashboardId = to.params.dashboardId

        const initialDashboards = get(window, 'appInitialData.dashboards', [])

        if (
          (initialDashboards === null
            // @ts-ignore // TODO: do not ignore
            || initialDashboards[dashboardId] === undefined
            // @ts-ignore // TODO: do not ignore
            || initialDashboards[dashboardId].shallow)
          && !TripDashboardStore.getters.Trip.id
        ) {
          // TODO: refactor this
          tripDashboardAxios.get(`${dashboardId}/get`).then(response => {
            if (response.status === 200) {
              setupDashboard(TripDashboardStore, dashboardId, response.data, () => {
                TripDashboardStore.commit('setClientUsers', response.data.clients)
                ready(TripDashboardStore)
                next()
              })
            } else {
              next(new Error('Trip not found.'))
              router.replace('/')
            }
          })
        } else {
          if (
            // @ts-ignore // TODO:
            parseInt(dashboardId) !== TripDashboardStore.state.Trips.currentTripDashboardId
          ) {
            TripDashboardStore.dispatch('setupTripResources', {
              id: dashboardId
            })
          }
        }
      } else {
        ready(TripDashboardStore)
      }
    }
    next()
  })

  // eslint-disable-next-line no-unused-vars
  router.afterEach((to: Route, _from: Route) => {
    if (get(TripDashboardStore, 'getters.User.id', null)) {
      UserActivityController.ping(TripDashboardStore.getters.User.id, 5, {
        section: to.name ? to.name : to.path
      })
    }
  })

  /*
  |--------------------------------------------------------------------------
  | EVENT BUS LISTENER
  | Listen for changes from React Assistant and refresh Vue 2 data
  |--------------------------------------------------------------------------
  */

  // @ts-ignore - window.tripDashboardEventBus is set up in eventBus.ts
  if (window.tripDashboardEventBus) {
    // Listen for user changes
    // @ts-ignore
    window.tripDashboardEventBus.on(
      'trip-dashboard:users-changed',
      (payload: { tripDashboardId: number }) => {
        const currentDashboardId = TripDashboardStore.getters.currentTripDashboardId

        // Only refresh if this event is for the currently active dashboard
        if (
          currentDashboardId && parseInt(String(currentDashboardId), 10) === payload.tripDashboardId
        ) {
          refreshTripDashboard(TripDashboardStore, payload.tripDashboardId).catch(
            (error: unknown) => {
              console.error('Failed to refresh trip dashboard after user change:', error)
            }
          )
        }
      }
    )

    // Listen for generic refresh requests from React Assistant
    // This allows the assistant to trigger a full refresh of the current dashboard
    // @ts-ignore
    window.tripDashboardEventBus.on(
      'trip-dashboard:refresh',
      (payload?: { tripDashboardId?: number }) => {
        const currentDashboardId = TripDashboardStore.getters.currentTripDashboardId

        // If no dashboardId specified, refresh the current one
        // If dashboardId specified, only refresh if it matches the current one
        const dashboardIdToRefresh = payload?.tripDashboardId || currentDashboardId

        if (
          currentDashboardId
          && parseInt(String(currentDashboardId), 10) === parseInt(String(dashboardIdToRefresh), 10)
        ) {
          refreshTripDashboard(TripDashboardStore, dashboardIdToRefresh).catch(
            (error: unknown) => {
              console.error('Failed to refresh trip dashboard:', error)
            }
          )
        }
      }
    )
  }

  /*
  |--------------------------------------------------------------------------
  | INIT APP
  |--------------------------------------------------------------------------
  */

  // @ts-ignore
  window.app = new Vue({
    el: '#trip-dashboard',
    components: {
      App
    },
    data: {},
    router,
    // @ts-ignore // TODO: do not ignore!
    store: TripDashboardStore
  })
}
